import React from "react";
import { observer } from "mobx-react";
import { TeamStatistics } from "@gp/models";

export const YellowCards = observer(function YellowCards({
	homeStats,
	awayStats,
}: {
	homeStats: TeamStatistics | undefined;
	awayStats: TeamStatistics | undefined;
}) {
	if (homeStats?.yellowCards == null && awayStats?.yellowCards == null) {
		return null;
	}

	return (
		<div className="event__stats__item">
			<div className="event__stats__icon">
				<i className="u-icon u-icon--sml u-icon--card u-icon--card--yellow u-align--v--middle" />
			</div>
			<div className="event__stats__value">
				<span>{homeStats?.yellowCards || 0}</span>
				<span> - </span>
				<span>{awayStats?.yellowCards || 0}</span>
			</div>
		</div>
	);
});
